import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { DatosBanco } from '../models/datos-banco';
import { map } from 'rxjs/operators';

const baseUrl = environment.hostService + '/DatosBancarios';

@Injectable({
  providedIn: 'root'
})
export class DatosBancosService {
    
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getHistoryByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(datosBanco: DatosBanco, cortarRegistro: boolean): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: datosBanco });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        banco: '', 
        cbu: '',
        cuentaBancaria: '',
        viaPago: '',
        moneda: '',
        errores: ['No Completar']}
    ];

    //banco, viaPago, moneda se deben validar que existan

    return formato;
  }
}

